import { AlertColor } from '@mui/material'
import { useSubmitContact } from '@src/api/contact-api'
import { CustomSnackbar } from '@src/components'
import { useState, FC, ChangeEvent } from 'react'
import { useTranslation } from 'react-i18next'
import ContactForm from './components/ContactForm'

const ContactUsContainer: FC = () => {
  const { t } = useTranslation()
  const [form, setForm] = useState({ name: '', email: '', message: '' })
  const [errors, setErrors] = useState({ name: '', email: '', message: '' })
  const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' })
  const [submitContact, isSubmitting] = useSubmitContact()

  const handleSubmit = async (e: React.ChangeEvent<HTMLFormElement>): Promise<void> => {
    e.preventDefault()
    const formErrors = {
      name: form.name ? '' : t('contact.nameRequired'),
      email: form.email ? '' : t('contact.emailRequired'),
      message: form.message ? '' : t('contact.messageRequired'),
    }

    setErrors(formErrors)
    if (Object.values(formErrors).some((error) => error !== '')) return

    try {
      await submitContact(form)
      setForm({ name: '', email: '', message: '' })
      setSnackbar({ open: true, message: t('userInfo.successMesage'), severity: 'success' })
    } catch (error) {
      setSnackbar({
        open: true,
        message: t('common.error', { message: (error as Error).message }),
        severity: 'error',
      })
    }
  }

  const handleChange = (name: string, event:  ChangeEvent<HTMLInputElement | HTMLTextAreaElement, Element>): void => {
    const value = event.target.value
    setForm((prevFormData) => {
      const newFormData = { ...prevFormData, [name]: value }
      return newFormData
    })
  }

  const handleCloseSnackbar = (): void => {
    setSnackbar((snak) => ({ ...snak, open: false }))
  }

  return (
    <>
      <ContactForm
        errors={errors}
        handleSubmit={handleSubmit}
        handleChange={handleChange}
        formData={form}
        isPending={isSubmitting}
      />
      <CustomSnackbar
        open={snackbar.open}
        message={snackbar.message}
        severity={snackbar.severity as AlertColor}
        onClose={handleCloseSnackbar}
      />
    </>
  )
}

export default ContactUsContainer
